var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlighter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3528 4786 c-26 -7 -69 -26 -95 -43 -73 -45 -2042 -1540 -2091 -1587 -24 -22 -58 -68 -75 -101 l-32 -60 0 -300 c0 -335 -9 -398 -80 -613 -77 -231 -71 -222 -405 -557 -323 -324 -325 -326 -277 -379 31 -36 737 -376 780 -376 29 0 54 22 237 205 l205 205 100 44 c121 53 231 88 367 118 94 21 130 23 403 23 l300 0 60 32 c33 17 81 53 105 79 82 89 1564 2052 1598 2116 58 112 53 250 -14 363 -28 49 -745 764 -794 793 -83 48 -197 63 -292 38z m203 -171 c44 -22 732 -709 754 -754 27 -54 31 -130 8 -182 -21 -48 -1548 -2069 -1591 -2107 -36 -31 -87 -52 -126 -52 -28 0 -101 70 -708 677 -643 642 -678 680 -678 713 0 23 12 55 33 88 27 44 88 94 417 343 212 160 667 505 1012 768 345 262 651 489 680 504 45 24 61 28 109 24 31 -3 71 -13 90 -22z m-1774 -2527 c299 -299 543 -546 543 -549 0 -3 -55 -9 -122 -12 -215 -12 -416 -58 -613 -142 l-108 -47 -224 224 -224 224 46 109 c85 202 131 402 142 613 3 67 9 122 12 122 3 0 250 -244 548 -542z m-632 -638 l210 -210 -151 -150 -150 -151 -114 57 c-63 31 -189 92 -279 136 -91 43 -167 81 -170 84 -5 5 429 444 439 444 3 0 100 -95 215 -210z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3594 3825 c-16 -7 -282 -267 -591 -577 -543 -543 -563 -565 -563 -601 0 -49 28 -77 77 -77 36 0 58 20 605 567 312 312 572 579 577 593 22 63 -43 122 -105 95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 457 c-20 -17 -27 -33 -27 -57 0 -24 7 -40 27 -57 l27 -23 1868 0 c1765 0 1870 1 1890 18 12 9 24 34 27 54 5 30 2 41 -19 62 l-26 26 -1870 0 -1870 0 -27 -23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlighter);
export default __webpack_public_path__ + "static/media/highlighter.e2e76225407c5bee65aa7bd7b1adff1c.svg";
export { ForwardRef as ReactComponent };